import { useEffect } from 'react';

function useScrollTop<T>(listening?: T) {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, [listening]);
}

export default useScrollTop;
